import { ApiVersion } from "./const/api-versions";
import { ServiceName } from "./const/service-names";
import { ModelBase } from "./model-base";

export class VersionInfo extends ModelBase {
  constructor(dataContext?: VersionInfo) {
    super();
    if (dataContext) {
      this.lastRestartDateTime = dataContext.lastRestartDateTime;
      this.serviceVersions = { ...dataContext.serviceVersions };
    }
  }

  private _lastRestartDateTime?: Date;
  private _serviceVersions: Record<ServiceName, ApiVersion> = null;

  get lastRestartDateTime(): Date {
    return this._lastRestartDateTime;
  }

  set lastRestartDateTime(value: any) {
    this._lastRestartDateTime = new Date(value);
  }

  get serviceVersions(): Record<ServiceName, ApiVersion> {
    return this._serviceVersions;
  }

  set serviceVersions(value: Record<ServiceName, ApiVersion>) {
    this._serviceVersions = value ?? null;
  }
}